import React from "react";
import PropTypes from "prop-types";
import { Card, Col, Row } from "react-bootstrap";
import RevShareModal from "../../common/overrides/RevShareModal";

const CashOutBlackoutCard = ({ blackedOut, toggleBlackout }) => {
  return (
    <Card>
      <Card.Header>
        <h3>Cash Out Blackout</h3>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col sm="8">
            <p>
              Temporary blackout periods can be enforced by toggling this option on and off. When turned on, consultants
              will be prevented from creating new Cash Out requests and a banner will be shown on the dashboard,
              available hours, and My Requests screen notifying users of the blackout.
            </p>
            <p>
              A blackout may need to be enforced if there is unfinalized Quarter data popluated in the Rev Share
              application, or if there have been data inconsistencies noticed that need to be looked into.
            </p>
            <p>
              <strong>A blackout period is currently: {`${blackedOut ? "Active" : "Inactive"}`}</strong>
            </p>
          </Col>
          <Col sm="4">
            <RevShareModal
              buttonText={`${blackedOut ? "End" : "Start"} Blackout`}
              buttonVariant="primary"
              modalSize="sm"
              selfClosing
              title={`Confirm ${blackedOut ? "End" : "Start"} Blackout`}
              yesButtonOnClick={toggleBlackout}
              yesButtonText={`${blackedOut ? "End" : "Start"}`}
            >
              <p>Are you sure you want to {`${blackedOut ? "end" : "start"}`} a blackout period?</p>
            </RevShareModal>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

CashOutBlackoutCard.propTypes = {
  blackedOut: PropTypes.bool.isRequired,
  toggleBlackout: PropTypes.func.isRequired,
};

export default CashOutBlackoutCard;
